export enum Feature {
  Enterprise = "enterprise",
}
